import { CatalogActions } from '../actions';
import { CatalogData } from '../catalog-state';

const initialState: CatalogData = { nodes: {} };

export function reducer(
  state = initialState,
  action: CatalogActions.CatalogLoadSuccess | CatalogActions.CatalogClearState | CatalogActions.CatalogSetState,
): CatalogData {
  switch (action.type) {
    case CatalogActions.LOAD_CATALOG_SUCCESS: {
      const { nodeId, ...data } = action.payload;

      return { ...state, nodes: { ...state.nodes, [nodeId]: data } };
    }

    case CatalogActions.CATALOG_SET_STATE: {
      return action.payload;
    }

    case CatalogActions.CATALOG_CLEAR_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
